const ID_TOKEN_KEY = "id_token";

export const getToken = () => {
  // return window.localStorage.getItem(ID_TOKEN_KEY);
  var arr,reg=new RegExp("(^| )"+ID_TOKEN_KEY+"=([^;]*)(;|$)");
  if(arr=document.cookie.match(reg)) return unescape(arr[2]);
  else return null;
};

export const saveToken = token => {
  // window.localStorage.setItem(ID_TOKEN_KEY, token);
  var Days = 30;
  var exp = new Date(); 
  exp.setTime(exp.getTime() + 120*60*1000);
  document.cookie = ID_TOKEN_KEY + "="+ escape (token) + ";expires=" + exp.toGMTString();
};

export const destroyToken = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};
export const saveUser = data => {
  window.localStorage.setItem("userinfo", JSON.stringify(data));
};
export const getUser = () => {
  if (window.localStorage.getItem('userinfo')) {
    return JSON.parse(window.localStorage.getItem('userinfo'));
  }
};
export default { getToken, saveToken, destroyToken,saveUser,getUser };
